import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import AboutSection from '../components/about/AboutSection';
import ValuesSection from '../components/about/ValuesSection';
import { AboutSEO } from '../components/layout/SEO';
import { usePageData } from '../contexts/DataContext';

const AboutPage = () => {
  const { data: aboutPage } = usePageData('aboutPage');

  React.useEffect(() => {
    document.body.style.paddingTop = '50px';
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="about-page">
        <AboutSEO pageData={aboutPage} />
        <AboutSection />
        <ValuesSection />
      </div>
    </HelmetProvider>
  );
};

export default AboutPage;